// extracted by mini-css-extract-plugin
export var callCard = "_ro-0";
export var callMessageButton = "_ro-1";
export var helpIcon = "_ro-3";
export var helpIconContainer = "_ro-4";
export var verticalDivider = "_ro-2";